<ng-template #header>
    <shared-header [center]="true" [brandAccent]="true" type="5" marginTop="md" marginBottom="none"
        class="modal-for-order-types__sub-h">
        HELP & INFORMATION
    </shared-header>

    <shared-header [center]="true" class="modal-for-order-types__h" type="2" marginTop="none" marginBottom="sm">
        Order pick up options
    </shared-header>
</ng-template>
<shared-modal-type-dynamic-height [header]="header" [modalData]="modalData" [center]="true" [mobilePreserve]="true"
    [size]="size" (onScrollInit)="handleScrollInit($event)" (onCloseClick)="handleCloseClick($event)"
    class="modal-for-order-types">

    <div class="modal-for-order-types__content">
        <shared-list-for-order-types [orderTypes]="(orderTypes$ | async)"></shared-list-for-order-types>
    </div>
</shared-modal-type-dynamic-height>